export default function IconLogoUnion() {
  return (
    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 60 60">
      <path
        fill="#252424"
        d="M16.528 9.765v21.276l.006-.006c0 .489.388.883.868.883h11.907c.746 0 1.145.9.648 1.471l-4.3 4.92a2.87 2.87 0 0 1-2.163.988H9.736c-.96 0-1.736-.789-1.736-1.766V9.765C8 8.788 8.775 8 9.736 8h5.056c.96 0 1.736.788 1.736 1.765Z"
      />
      <path
        fill="#252424"
        d="M31.513 20.703h18.485v.006c.96 0 1.736.789 1.736 1.765v3.419c0 .718-.26 1.412-.73 1.953L37.16 43.692c-.33.376-.064.977.434.977h12.67c.96 0 1.736.788 1.736 1.765v3.8c0 .977-.775 1.766-1.736 1.766H26.26c-.96 0-1.736-.788-1.736-1.765v-3.419c0-.718.26-1.412.729-1.953l13.845-15.846c.33-.376.064-.976-.434-.976H25.739c-.747 0-1.146-.9-.648-1.471l4.258-4.878a2.87 2.87 0 0 1 2.164-.989Z"
      />
    </svg>
  );
}
